<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-41"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{$t("title.system.fixdesk.title")}}</label>
        <narrow-down
          @click="FixDeskMapInfo"
          v-auth="{ auth: '040701'}"
          slot="cancel">
          {{ $t("label.system.fixdesk.search.query.mapInfo") }}
        </narrow-down>
        <narrow-down
          @click="createFixDesk"
          v-auth="{ auth: '040102'}"
          slot="create">
          {{ $t("label.system.fixdesk.search.query.create") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <div class="panel-search margin-bottom">
        <el-form
          :model="query"
          :rules="rules"
          ref="ruleForm"
          class="search-form">
          <!-- オーナー -->
          <div class="fm-row">
            <el-form-item
              prop="ownerExId">
                <el-input
                  maxlength="20"
                  class="fm-input"
                  v-model="query.ownerExId"
                  :placeholder="$t('label.system.fixdesk.search.query.ownerExId') +
                    $t('label.system.owner.search.prompt.partialMatchs')">
                </el-input>
            </el-form-item>
            <sp-smart-lable-button class="fm-lb-btn line-limit-length" v-show="query.ownerName">
              {{ query.ownerName }}
            </sp-smart-lable-button>
            <button-index @click="selectOwner" class="fm-st-btn limit-length">
              {{$t("button.common.select")}}
            </button-index>
          </div>
          <!-- ビル -->
          <div class="fm-row">
            <el-form-item
              prop="buildingExId">
                <el-input
                  maxlength="20"
                  class="fm-input"
                  v-model="query.buildingExId"
                  :placeholder="$t('label.system.fixdesk.search.query.buildingExId') +
                    $t('label.system.owner.search.prompt.partialMatchs')">
                </el-input>
            </el-form-item>
            <sp-smart-lable-button class="fm-lb-btn line-limit-length" v-show="query.buildingName">
              {{ query.buildingName }}
            </sp-smart-lable-button>
            <button-index @click="selectBuilding" class="fm-st-btn limit-length">
              {{$t("button.common.select")}}
            </button-index>
          </div>
          <!-- フロア -->
          <div class="fm-row">
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.floorName"
                :placeholder="$t('label.system.fixdesk.search.query.floorSelect')"
              >
              </el-input>
            </el-form-item>
            <button-index @click="selectFloor" class="fm-st-btn limit-length">
              {{$t("button.common.select") }}
            </button-index>
          </div>
          <!-- エリア名 -->
          <div class="fm-row">
            <el-form-item>
              <el-input
                :readonly="true"
                clearable
                maxlength="50"
                class="fm-input"
                v-model="query.areaName"
                :placeholder="$t('label.system.fixdesk.search.query.areaSelect')"
              >
              </el-input>
            </el-form-item>
            <button-index class="fm-st-btn limit-length" @click="selectArea">
              {{$t("button.common.select") }}
            </button-index>
          </div>
          <!-- 会議室名 -->
          <div class="fm-row">
            <el-form-item
              size="small"
              prop="meetingRoomName"
            >
              <el-input
                maxlength="50"
                v-model="query.meetingRoomName"
                class="fm-input"
                :placeholder="$t('label.common.fixDeskNamePlaceHolder')"
              ></el-input>
            </el-form-item>
          </div>
          <div class="fm-row btn-area">
            <narrow-down @click="searchFixDesk">
              {{ $t("button.common.narrow") }}
            </narrow-down>
            <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
              {{ $t("button.common.data.cleanUp") }}
            </cancel-narrow-down>
            <narrow-down
              v-auth="{ auth:'040107' }"
              class="download-btn"
              @click="download"
              slot="cancel">
              {{ $t("button.system.account.search.csvDownload") }}
            </narrow-down>
            <!-- v-auth="{ auth: '010101' }" -->
            <narrow-down
              v-auth="{ auth:'040108' }"
              class="download-btn"
              style="margin-left: 20px;"
              @click="upload"
              slot="cancel">
              {{ $t("button.system.account.search.csvUpload") }}
            </narrow-down>
          </div>
        </el-form>
      </div>
      <!--   検索エリア終了   -->
      <div>
        <el-row v-show="isShow">
          <label v-show="isShow" class="list-title">{{ $t("label.system.fixdesk.search.query.fixDeskList") }}</label>
          <div class="text-right">
            <label class="label-right lable-right-16">{{ $t("label.common.count") }}</label>
            <el-select
              @change="changePageSize"
              v-model="query.pageSize"
              class="zdyselect">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-row>
      </div>

      <el-row class="margin-top-28" ref="searchResultTable" id="search-result">
        <div v-if="this.isShow">
          <fix-desk-search-result-beautify
            :result="searchResult.body"
            :isShow="this.isShow"
            @on-detail="detailMeetingRoom"
            @on-edit="editMeetingRoom"
            @on-delete="deleteMeetingRoom"
          />
        </div>
      </el-row>
      <!--   検索結果が表示されます end   -->
      <!--  pagination start  -->
      <div style="margin-top: 70px">
        <pagination
          v-show="searchResult.totalCount > 0"
          :page-size="query.pageSize"
          :page-number="searchResult.pageNumber"
          :totalPage="searchResult.totalPage"
          :totalCount="searchResult.totalCount"
          @on-paging="handlePagingAction"
        />
      </div>
      <!--  pagination end  -->

      <!-- オーナー選択子画面 -->
      <owner-search-popup
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :ownerId="query.ownerExId"
        :visible.sync="ownerSearchFlg"
        @on-selected="getOwnerInfo"
      />

      <!-- ビル選択子画面 -->
      <building-search-popup
        :ownerIdParam="query.ownerId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :visible.sync="buildingSearchFlg"
        @on-selected="getBuildingInfo"
      />

      <!-- フロア選択子画面 -->
      <floor-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorNameParam="query.floorName"
        :visible.sync="floorSearchFlg"
        @on-selected="getFloorInfo"
      />

      <!-- エリア選択子画面 -->
      <area-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorIdParam="query.floorId"
        :areaNameParam="query.areaName"
        :visible.sync="areaSearchFlg"
        @on-selected="getAreaInfo"
      />

      <file-downloader-loading-dialog :dialogVisible="showLoading" />
    </div>
    <!--  body end  -->
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout"
import FixDeskSearchResultBeautify from "@/components/system/FixDeskSearchResultBeautify"
import Pagination from "@/components/common/pagination/Pagination"
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup"
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup"
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup"
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup"
import RuleMeetingRoomSearch from "@/rules/rule-fixdesk-search"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
import buttonIndex from "@/components/common/sp-smart-button/index"
// import labelButton from "@/components/common/sp-smart-lable-button/index"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import SpSmartLableButton from "@/components/common/sp-smart-lable-button"
import fileDownloader from "@/utils/file-downloader";
// import SpSmartButton from "@/components/common/sp-smart-button"
import FileDownloaderLoadingDialog from "@/components/common/loading/FileDownloaderLoadingDialog"

const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_NUMBER = 1

export default {
  name: "FixDeskSearch",
  components: {
    MainLayout: MainLayout,
    FixDeskSearchResultBeautify: FixDeskSearchResultBeautify,
    Pagination: Pagination,
    Menubar: Menubar,
    OwnerSearchPopup: OwnerSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    FloorSearchPopup: FloorSearchPopup,
    AreaSearchPopup: AreaSearchPopup,
    narrowDown: narrowDown,
    cancelNarrowDown: cancelNarrowDown,
    buttonIndex: buttonIndex,
    // labelButton: labelButton,
    headTitle: headTitle,
    SpSmartLableButton: SpSmartLableButton,
    FileDownloaderLoadingDialog
  },
  data() {
    return {
      showLoading: false,
      ownerSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg: false,
      areaSearchFlg: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floorName: null,
        areaId: null,
        areaName: null,
        meetingRoomName: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalCount: 0,
      },
      //結果宣言に戻る
      isShow: false,
      rules: RuleMeetingRoomSearch.meetingroomSearchRules(this),
      isSearching: false,
      tableLoadingAnim: null,
      searchResult: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 0,
        pageNumber: 0,
        body: [
          {
            ownerName: null,
            ownerExId: null,
            ownerId: null,
            buildingName: null,
            buildingExId: null,
            buildingId: null,
            floorId: null,
            floorName: null,
            areaId: null,
            areaName: null,
            meetingRoomId: null,
            meetingRoomName: null,
            capacity: null,
          },
        ],
      },
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  methods: {
    FixDeskMapInfo(){
      this.$router.push({
        name: "system-fixDesk-mapinfo-new",
      });
      this.$saveQueryParam("fix_desk_map_id", null)
    },
    changePageSize(){
      this.query.pageNumber = 1
      this.doneSearchfixDesk();
    },
    //会議室新規
    createFixDesk() {
      this.$saveQueryParam("fix_desk_search_id", this.query)
      this.$router.push({
        name: "system-fixDesk-create",
      });
    },
    //オーナー選択
    selectOwner() {
      this.ownerSearchFlg = true;
    },
    //ビル選択
    selectBuilding() {
      this.buildingSearchFlg = true;
    },
    //フロア選択
    selectFloor() {
      this.floorSearchFlg = true;
    },
    //エリア選択
    selectArea() {
      this.areaSearchFlg = true;
    },
    //照会バータン
    detailMeetingRoom(meetingRoomId) {
      this.$saveQueryParam("fix_desk_search_id", this.query)
      this.$router.push({
        name: "system-fixDesk-detail",
        params: {
          meetingRoomId: meetingRoomId,
        },
      });
    },
    //編集バータン
    editMeetingRoom(meetingRoomId) {
      this.$router.push({
        name: "system-fixDesk-edit",
        params: {
          meetingRoomId: meetingRoomId,
        },
      });
    },
    //削除バータン
    deleteMeetingRoom(meetingRoomId, index) {
      this.showTableLoadingAnim();
      SystemManageApi.deleteFixDesk(meetingRoomId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          let meetingRooms = this.searchResult.body;
          meetingRooms.splice(index, 1);
          this.deleteSuccess();
        })
        .finally(() => {
          this.hideTableLoadingAnim();
          this.searchFixDesk();
        });
    },
    //検索
    searchFixDesk() {
      this.$saveQueryParam("fix_desk_search_id", this.query)
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.doneSearchfixDesk();
        }
      });
    },
    //クリア
    clearSearchParams() {
      this.$saveQueryParam("fix_desk_search_id", null),
      (this.query.ownerId = null),
        (this.query.ownerExId = null),
        (this.query.ownerName = null),
        (this.query.buildingId = null),
        (this.query.buildingExId = null),
        (this.query.buildingName = null),
        (this.query.floorId = null),
        (this.query.floorName = null),
        (this.query.areaId = null),
        (this.query.areaName = null),
        (this.query.meetingRoomName = null),
        (this.query.pageSize = DEFAULT_PAGE_SIZE),
        (this.query.pageNumber = DEFAULT_PAGE_NUMBER),
        (this.query.totalCount = 0),
        (this.searchResult.totalPage = 0),
        (this.searchResult.totalCount = 0),
        (this.searchResult.body = []),
        (this.isShow = false),
        this.$refs["ruleForm"].resetFields();
    },
    //处理pagination事件
    handlePagingAction(pagination) {
      this.query.pageSize = pagination.pageSize;
      this.query.pageNumber = pagination.pageNumber;
      this.searchFixDesk();
      this.$refs.searchResultTable.$el.scrollIntoView()
    },
    //オーナー選択-子组件
    getOwnerInfo: function (owner) {
      if (this.query.ownerId != owner.id) {
        this.query.buildingId = null;
        this.query.buildingExId = null;
        this.query.buildingName = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = owner.id;
      this.query.ownerName = owner.name;
      this.query.ownerExId = owner.exId;
    },
    //获取 ビル選択 子画面的值
    getBuildingInfo(building) {
      if (this.query.buildingId != building.buildingId) {
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerExId = building.ownerExId;
      this.query.ownerName = building.ownerName;
      this.query.buildingId = building.buildingId;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingName = building.buildingName;
    },
    //获取 フロア選択子画面的值
    getFloorInfo(floor) {
      if (this.query.floorId != floor.floorId) {
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = floor.ownerId;
      this.query.ownerName = floor.ownerName;
      this.query.ownerExId = floor.ownerExId;
      this.query.buildingName = floor.buildingName;
      this.query.buildingExId = floor.buildingExId;
      this.query.buildingId = floor.buildingId;
      this.query.floorName = floor.floorName;
      this.query.floorId = floor.floorId;
    },
    //获取 エリア選択子画面的值
    getAreaInfo(area) {
      this.query.ownerId = area.ownerId;
      this.query.ownerExId = area.ownerExId;
      this.query.ownerName = area.ownerName;
      this.query.buildingId = area.buildingId;
      this.query.buildingExId = area.buildingExId;
      this.query.buildingName = area.buildingName;
      this.query.floorId = area.floorId;
      this.query.floorName = area.floorName;
      this.query.areaId = area.areaId;
      this.query.areaName = area.areaName;
    },
    //会議室检索
    doneSearchfixDesk() {
      if (!this.isSearching) {
        this.isSearching = true;
        this.showTableLoadingAnim();
        this.searchResult.body = [];
        SystemManageApi.searchFixDesk({
          pageSize: this.query.pageSize,
          pageNumber: this.query.pageNumber,
          ownerId: this.query.ownerId,
          ownerExId: this.query.ownerExId,
          ownerName: this.query.ownerName,
          buildingId: this.query.buildingId,
          buildingExId: this.query.buildingExId,
          buildingName: this.query.buildingName,
          floorId: this.query.floorId,
          areaName: this.query.areaName,
          areaId: this.query.areaId,
          roomName: this.query.meetingRoomName,
        })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            this.searchResult.totalCount = data.body.totalCount;
            this.searchResult.totalPage = data.body.totalPage;
            this.searchResult.pageSize = data.body.pageSize;
            this.searchResult.pageNumber = data.body.pageNumber;

            for (let bodys of data.body.body) {
              this.searchResult.body.push({
                ownerName: bodys.ownerName,
                ownerExId: bodys.ownerExId,
                ownerId: bodys.ownerId,
                buildingName: bodys.buildingName,
                buildingExId: bodys.buildingExId,
                buildingId: bodys.buildingId,
                floorId: bodys.floorId,
                // floorName: bodys.floorName + " "+this.$t('label.system.meetingRoom.create.floorNames'),
                floorName: bodys.floorName,
                deleteFlag: bodys.deleteFlag,
                areaId: bodys.areaId,
                areaName: bodys.areaName,
                meetingRoomId: bodys.roomId,
                meetingRoomName: bodys.roomName,
                capacity: bodys.capacity == 21 ? '21名以上' : bodys.capacity + " "+this.$t('label.system.meetingRoom.create.capacitySuffix'),
              });
            }
          })
          .finally(() => {
            this.isSearching = false;
            this.hideTableLoadingAnim();
            this.isShow = true;
          });
      }
    },
    //显示表格加载动画
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        });
      }
    },
    //隐藏表格加载动画
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    //削除
    deleteSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.delete", {
        field: this.$t("message.common.validation.fixDesksMessage"),
      }));
    },
    download() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
        this.showLoading = true;
        SystemManageApi.batchExport({
          pageSize: this.query.pageSize,
          pageNumber: this.query.pageNumber,
          ownerId: this.query.ownerId,
          ownerExId: this.query.ownerExId,
          ownerName: this.query.ownerName,
          buildingId: this.query.buildingId,
          buildingExId: this.query.buildingExId,
          buildingName: this.query.buildingName,
          floorId: this.query.floorId,
          areaName: this.query.areaName,
          areaId: this.query.areaId,
          roomName: this.query.meetingRoomName,
        }, '06')
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(( data ) => {
            this.showLoading = false;

            const blob = data.data;

            // レスポンスの Content-Type が application/json の場合
            // → ファイルではなくエラー情報（JSON）が返却されている可能性がある
            if (blob.type && blob.type.includes('application/json')) {

              // Blob データを文字列に変換
              blob.text().then(text => {

                // JSON 文字列をオブジェクトに変換
                const json = JSON.parse(text);

                // エラーメッセージおよびダウンロード上限数が存在する場合
                if (json.errorMessage && json.downloadMaxCount) {

                  // ダウンロード上限超過のエラーメッセージを表示
                  this.$messageIotError(
                    this.$t(
                      'message.common.csvImport.ERR_FILE_EXCEEDED_DOWNLOAD_LIMIT_MSG',
                      { maxCount: json.downloadMaxCount }
                    )
                  );

                  // エラーのため、以降の処理を中断
                  return;
                }
              });

            } else {
              // JSON 以外の場合
              // ファイルダウンロード処理を実行
              fileDownloader(data);
            }

          })
          .finally(() => {
            this.showLoading = false;
          });
        }else{
          this.$refs.download.setAttribute('disabled',true);
        }
      })
    },
    upload() {
      this.$router.push({
        name: "import-page",
        query: {
          type: '06',
          screenIdParam: "M-06-41"
        }
      })
    },
  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
    let queryObj = this.$getQueryParam("fix_desk_search_id")
    if(queryObj!=null){
      this.query = queryObj
      this.searchFixDesk();
    }
  },
  created() {
    this.$authCheck("040101")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.router.FixDesk",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
};
</script>

<style lang="scss" scoped>

::v-deep .fm-row .download-btn{
  .my-button{
    color: #525250;
    font-size: 13px;
    background-color: #f7f7f2 !important;
    left: 55px;
    position: relative;
    height: 40px;
    width: 188px;
    text-align: center;
  }
}

::v-deep .cancel-width{
  .my-button{
    width: 188px;
    height: 32px;
  }
}

.margin-bottom{
  margin-bottom: 60px;
}
::v-deep .new-input-style {
  width: 324px;
  .el-input__inner{
    width: 324px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #F2F2ED;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
  }
}
.div-margin{
  //margin-top: 20px;
  //margin-left: 20px;
}
.margin-right-20{
  margin-right: 20px;
}
.line-limit-length {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-margin{
  margin-top: 4px;
}
.margin-left-20{
  margin-left: 20px;
}
.el-form-item{
  margin-bottom: 24px;
}
.el-row{
  ::v-deep .el-form-item--small.el-form-item{
    //margin-bottom: 30px !important;
  }
}


::v-deep .zdyselect {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 15px;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }
  .el-input__suffix {
    top: 0px;
  }
  .el-input__icon {
    line-height: 25px !important;
  }
}
::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #525250;
    border: 2px solid;
    border-color: #bce0fd;
    font-size: 12px;
  }
  .el-input__inner::placeholder {
    color: #bce0fd;
  }
  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}
.label-right{
  position: relative;
  right: 10px;
  font-size: 16px;
}

.select-button {
  width: 146px;
}

.limit-length {
   width: 100px !important;
}

::v-deep .cancel {
  .my-button {
    font-family: "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", "Meiryo", "ＭＳ ゴシック", sans-serif;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    color: #525250;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    padding: 10px 20px;
    font-size: 13px;
    border-radius: 8px;
    width: 188px;
    height: 32px;
    z-index: 600;
    background-color: #f2f2ed;
    border: 0;
  }
}
</style>
